<template>
  <div id="container">
    <router-view></router-view>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { initPostHog } from '@app/composables/posthog';
import { captureInboundCampaign } from '@app/consts/store-links';

// Deliberately leaner than App.vue: the marketing site needs neither unhead (its meta tags
// are static in index.html) nor the shared-components library, and pulling either in would
// drag PrimeVue and lottie back into this entry's bundle.
onMounted(() => {
  captureInboundCampaign();
  initPostHog();
});
</script>

<style lang="scss">
@use '@assets/css/app-shell.scss';
</style>
